import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { useOutletContext } from "react-router-dom";
import "./home.css";

const Home = () => {
	const [selectedSymbol, setSelectedSymbol] = useState("FX_IDC:AUDCAD");
	const { user } = useOutletContext();
	useEffect(() => {
		// Создаем скрипт для TradingView
		const script = document.createElement("script");
		script.src = "https://s3.tradingview.com/tv.js";
		script.async = true;

		// Конфигурация виджета Superchart
		script.onload = () => {
			new window.TradingView.widget({
				symbol: selectedSymbol, // Укажите нужный тикер (акции, валюты, криптовалюты и т.д.)
				container_id: "superchart_container", // ID контейнера для графика
				width: "100%",
				height: "600",
				theme: "dark", // или 'dark'
				interval: "1", // Интервал (например, 'D' - дневной график)
				timezone: "Etc/UTC",
				style: "1", // Тип графика: '1' - свечи, '9' - линии
				locale: "ru", // Язык интерфейса
				enable_publishing: false, // Отключить публикацию идей
				allow_symbol_change: true, // Разрешить изменение тикеров
				hide_top_toolbar: false, // Показать верхнюю панель инструментов
				hide_side_toolbar: false, // Показать боковую панель инструментов
				save_image: false, // Отключить сохранение графика как изображения
			});
		};

		// Добавляем скрипт в DOM
		document.getElementById("superchart-wrapper").appendChild(script);
	}, []);

	useEffect(() => {
		// Проверяем, существует ли уже виджет
		if (document.getElementById("tradingview-widget-script")) return;

		const script = document.createElement("script");
		script.id = "tradingview-widget-script"; // Уникальный ID для скрипта
		script.src =
			"https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
		script.async = true;

		script.innerHTML = JSON.stringify({
			colorTheme: "dark",
			dateRange: "12M",
			showChart: true,
			locale: "ru",
			largeChartUrl: "",
			isTransparent: true,
			width: "100%",
			height: "500",
			tabs: [
				{
					title: "Индексы",
					symbols: [
						{ s: "FOREXCOM:SPXUSD", d: "S&P 500" },
						{ s: "FOREXCOM:NSXUSD", d: "Nasdaq 100" },
						{ s: "FOREXCOM:DJI", d: "Dow 30" },
						{ s: "INDEX:DAX", d: "DAX 30" },
						{ s: "INDEX:NIKKEI", d: "Nikkei 225" },
						{ s: "INDEX:FTSE", d: "FTSE 100" },
						{ s: "INDEX:HSI", d: "Hang Seng" },
					],
				},
				{
					title: "Товары",
					symbols: [
						{ s: "CME_MINI:ES1!", d: "E-Mini S&P" },
						{ s: "CME:6E1!", d: "Euro" },
						{ s: "COMEX:GC1!", d: "Gold" },
						{ s: "NYMEX:CL1!", d: "Crude Oil" },
						{ s: "NYMEX:NG1!", d: "Natural Gas" },
						{ s: "COMEX:SI1!", d: "Silver" },
						{ s: "CBOT:ZC1!", d: "Corn" },
					],
				},
				{
					title: "Криптовалюты",
					symbols: [
						{ s: "BITSTAMP:BTCUSD", d: "Bitcoin" },
						{ s: "BITSTAMP:ETHUSD", d: "Ethereum" },
						{ s: "BINANCE:BNBUSDT", d: "Binance Coin" },
						{ s: "BINANCE:SOLUSDT", d: "Solana" },
						{ s: "BINANCE:ADAUSDT", d: "Cardano" },
						{ s: "BINANCE:XRPUSDT", d: "Ripple" },
						{ s: "BINANCE:DOGEUSDT", d: "Dogecoin" },
					],
				},
				{
					title: "Валюты",
					symbols: [
						{ s: "FX:EURUSD", d: "EUR/USD" },
						{ s: "FX:GBPUSD", d: "GBP/USD" },
						{ s: "FX:USDJPY", d: "USD/JPY" },
						{ s: "FX:USDCAD", d: "USD/CAD" },
						{ s: "FX:AUDUSD", d: "AUD/USD" },
						{ s: "FX:USDCHF", d: "USD/CHF" },
					],
				},
				{
					title: "Фьючерсы",
					symbols: [
						{ s: "CME:GC1!", d: "Gold Futures" },
						{ s: "CME:CL1!", d: "Crude Oil Futures" },
						{ s: "CBOT:ZC1!", d: "Corn Futures" },
						{ s: "CME:ES1!", d: "S&P 500 E-Mini" },
						{ s: "CME:6E1!", d: "Euro Futures" },
					],
				},
			],
		});

		document.getElementById("market-table-wrapper").appendChild(script);
	}, []);

	useEffect(() => {
		if (document.getElementById("tradingview-screener-script")) return;

		const script = document.createElement("script");
		script.src =
			"https://s3.tradingview.com/external-embedding/embed-widget-screener.js";
		script.async = true;
		script.id = "tradingview-screener-script";

		script.innerHTML = JSON.stringify({
			container_id: "tradingview-screener",
			width: "100%",
			height: 400,
			defaultScreen: "general",
			defaultColumn: "overview",
			defaultTab: "stocks",
			colorTheme: "dark",
			locale: "ru",
			showToolbar: true,
			isTransparent: true,
			onSelectionChange: (data) => {
				console.log(data); // Ваши данные из таблицы
			},
		});

		document.getElementById("screener-wrapper").appendChild(script);
	}, []);
	useEffect(() => {
		if (document.getElementById("tradingview-ticker-tape")) return;

		const script = document.createElement("script");
		script.src =
			"https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
		script.async = true;
		script.id = "tradingview-ticker-tape";

		script.innerHTML = JSON.stringify({
			symbols: [
				{ proName: "FOREXCOM:SPXUSD", title: "S&P 500" },
				{ proName: "FOREXCOM:NSXUSD", title: "Nasdaq 100" },
				{ proName: "FOREXCOM:DJI", title: "Dow Jones" },
				{ proName: "INDEX:DAX", title: "DAX 30" },
				{ proName: "INDEX:NIKKEI", title: "Nikkei 225" },
				{ proName: "BITSTAMP:BTCUSD", title: "Bitcoin" },
				{ proName: "BITSTAMP:ETHUSD", title: "Ethereum" },
				{ proName: "CME_MINI:ES1!", title: "S&P 500 Futures" },
				{ proName: "COMEX:GC1!", title: "Gold" },
				{ proName: "NYMEX:CL1!", title: "Crude Oil" },
			],
			colorTheme: "dark",
			isTransparent: true,
			displayMode: "adaptive",
			locale: "ru",
		});

		document.getElementById("ticker-tape-wrapper").appendChild(script);
	}, []);

	useEffect(() => {
		if (document.getElementById("tradingview-single-ticker")) return;

		const script = document.createElement("script");
		script.src =
			"https://s3.tradingview.com/external-embedding/embed-widget-single-quote.js";
		script.async = true;
		script.id = "tradingview-single-ticker";

		script.innerHTML = JSON.stringify({
			symbol: selectedSymbol, // Символ для отображения, например, Bitcoin
			width: "350", // Ширина виджета
			colorTheme: "dark", // Темная тема
			isTransparent: true, // Прозрачность фона
			locale: "ru", // Язык виджета
		});

		document.getElementById("single-ticker-wrapper").appendChild(script);
	}, []);

	return (
		<div className="trade">
			<div
				id="ticker-tape-wrapper"
				style={{
					width: "100%",
					height: "48px",
				}}
			/>
			<div className="trade-wrapper">
				<div className="trade-market">
					<div className="trade-market-item">
						<div className="trade-market-item-title">Рынок</div>
						<div
							id="market-table-wrapper"
							style={{ height: "500px", width: "100%" }}
						/>
					</div>
				</div>
				<div id="superchart-wrapper" style={{ height: "400px", width: "100%" }}>
					<div
						id="superchart_container"
						style={{ height: "600px", width: "100%" }}
					/>
				</div>
			</div>
			<div className="trade-screener">
				<div
					id="screener-wrapper"
					style={{
						width: "50%",
						height: "400px",
					}}
				/>
				<div className="trade-screener-trade">
					{user.balance < 0 && (
						<div className="trade-screener-trade-mask">
							<img src="/icons/shield.svg" alt="shield" />
							<p className="trade-screener-trade-mask-title">
								Необходимо пополнить баланс
							</p>
						</div>
					)}
					<div className="trade-screener-trade-wrapper">
						<div
							id="single-ticker-wrapper"
							style={{
								width: "100%",
							}}
						/>
						<TextField id="some-basic" label="Количество" variant="outlined" />
						<FormControl fullWidth>
							<InputLabel id="demo-simple-select-label">Аккаунт</InputLabel>
							<Select
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								label="Аккаунт"
							>
								<MenuItem value={10}>USD Основной</MenuItem>
							</Select>
						</FormControl>
						<Button
							variant="contained"
							color="success"
							disabled
							sx={{ width: "70%", height: "50px", margin: "0 auto", mt: 2 }}
						>
							Купить
						</Button>
					</div>
					<div className="trade-screener-trade-table">
						<h2 className="trade-screener-trade-table-title">Транзакции</h2>
						<div className="trade-screener-trade-table-titles">
							<div className="trade-screener-trade-table-titles-item">Тикер</div>
							<div className="trade-screener-trade-table-titles-item">Количество</div>
							<div className="trade-screener-trade-table-titles-item">Цена</div>
							<div className="trade-screener-trade-table-titles-item">Дата</div>
						</div>
						<div className="trade-screener-trade-table-items">
							<p>Транзакции не найдены</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Home;
